/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbActionsModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSidebarModule,
  NbUserModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbSpinnerModule,
  NbThemeModule,
  NbBadgeModule,
  NbCardModule,
  NbListModule,
  NbChatModule,
  NbTooltipModule,
  NbPopoverModule
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbSecurityModule } from '@nebular/security';
import { AuthModule } from '../@auth/auth.module';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import {
  FooterComponent,
  HeaderComponent,
  SearchInputComponent,
  TinyMCEComponent,
} from './components';
import {
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
} from './pipes';
import {
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
} from './layouts';
import { InitUserService } from './services/init-user.service';

import { DEFAULT_THEME } from './styles/theme.default';
import { COSMIC_THEME } from './styles/theme.cosmic';
import { CORPORATE_THEME } from './styles/theme.corporate';
import { DARK_THEME } from './styles/theme.dark';
import { UsecommonModule } from './components/common/usecommon.module';
import { NumberToWordsPipe } from './pipes/numberToWords.pipe';
import { EzoChatAppModule } from './components/common/ezo-chat-app/ezo-chat-app.module';
import { AmountFormatPipe } from './pipes/amount-Format.pipe';
import { QrCodeComponent } from './components/qr-code/qr-code.component';
import { ImageAnnotationComponent } from './components/image-annotation/image-annotation.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PreventMultipleClicksDirective } from './directives/prevent-multiple-clicks.directive';
import { DynamicRequiredFieldDirective } from './directives/dynamic-required-field.directive';
import { PopupComponent } from './components/popup/popup.component';
import { CustomTextTrimDirective } from './directives/custom-text-trim.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PacsQueueComponent } from './components/pacs-queue/pacs-queue.component';

const NB_MODULES = [
 NbCardModule,
  NbListModule,
  NbChatModule,
  NbBadgeModule,
  NbTooltipModule,
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbSpinnerModule,
  NbEvaIconsModule,
  NbPopoverModule,
  MatIconModule,
  MatFormFieldModule,
  MatSelectModule,
  MatDialogModule
];
const COMPONENTS = [
  PopupComponent,
  HeaderComponent,
  FooterComponent,
  SearchInputComponent,
  TinyMCEComponent,
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
  QrCodeComponent,
  ImageAnnotationComponent,
];
const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
  NumberToWordsPipe,
  AmountFormatPipe
];

const DIRECTIVES=[PreventMultipleClicksDirective,DynamicRequiredFieldDirective,CustomTextTrimDirective];

@NgModule({
  imports: [CommonModule, AuthModule, ...NB_MODULES, UsecommonModule, EzoChatAppModule, MatTooltipModule],
  exports: [CommonModule, ...PIPES, ...COMPONENTS, NbPopoverModule, UsecommonModule, NB_MODULES, ...DIRECTIVES],
  declarations: [...COMPONENTS, ...PIPES, ...DIRECTIVES, PacsQueueComponent],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        NbThemeModule.forRoot(
          {
            name: 'default',
          },
          [ DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME, DARK_THEME ],
        ).providers,
        InitUserService,
      ],
    };
  }
}
